"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _edSystem = require("@eduact/ed-system/");
var _Theme = require("../..//Theme");
var useStudentScreenSize = function useStudentScreenSize(args) {
  var _useThemeScreenSize = (0, _edSystem.useThemeScreenSize)({
      sm: _Theme.Theme.breakpointsInPx.sm,
      md: _Theme.Theme.breakpointsInPx.md,
      lg: _Theme.Theme.breakpointsInPx.lg,
      xl: _Theme.Theme.breakpointsInPx.xl,
      lgWithXl: args === null || args === void 0 ? void 0 : args.lgWithXl
    }),
    isDesktop = _useThemeScreenSize.isDesktop,
    isLargeScreen = _useThemeScreenSize.isLargeScreen,
    isMobile = _useThemeScreenSize.isMobile,
    isTablet = _useThemeScreenSize.isTablet;
  return {
    isDesktop: isDesktop,
    isLargeScreen: isLargeScreen,
    isMobile: isMobile,
    isTablet: isTablet
  };
};
var _default = useStudentScreenSize;
exports["default"] = _default;